module.exports = __webpack_public_path__ + "img/logotype.2a2558a1.svg";